<template>
  <EcosystemInfoCard>
    <ul>
      <li v-for="label in labels" :key="label.text">
        <div class="label-section">
          <icon v-if="label.icon" :name="label.icon"></icon>
          <span v-else class="label-color"
                :style="{ backgroundColor: label.color }"></span>
          {{ label.text }}
        </div>
        <template v-if="showFinalValue && label.finalValue >= 0">
          <div class="value-section">
            <h3 class="h3">
              {{ label.finalValue }}
            </h3>
          </div>
        </template>
      </li>
    </ul>
  </EcosystemInfoCard>
</template>

<script>
  import EcosystemInfoCard from './EcosystemInfoCard.vue'

  export default {
    props: {
      data: Object,
      showFinalValue: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      labels () {
        if (!this.data) {
          return []
        }
        return this.data.datasets.map(dataset => ({
          color: dataset.borderColor,
          icon: dataset.icon,
          finalValue: dataset.finalValue,
          text: dataset.label,
        }))
      },
    },
    components: {
      EcosystemInfoCard,
    },
  }
</script>

<style lang="scss" scoped>
  ul {
    color: #6b7280;
    margin-left: 0;
    margin-bottom: -4px;
    margin-top: -4px;
    text-transform: uppercase;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.04em;
  }

  li {
    display: flex;
    flex-direction: column;
    padding: 8px 4px;

    + li {
      border-top: 1px solid #f3f4f6;
    }

    .label-section {
      display: flex;
      align-items: center;
    }

    .value-section {
      font-size: 24px;
      font-weight: 600;
      color: #111827;
      margin-top: 4px;
    }
  }

  .label-color {
    display: block;
    border-radius: 9999px;
    height: 10px;
    margin-right: 8px;
    width: 10px;
  }
</style>
